module.exports = __webpack_public_path__ + "img/chordline-screenshot.6687ff62.png";